import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Image, Message } from 'semantic-ui-react';
import { Sel } from 'uix/registries';
import { Link } from 'uix/components';
import { useApi, useGraphics, useSelector } from 'uix/hooks';
import { encodeSlimLink } from 'uix/utils';
import { DatatypeDescription } from 'uix/types/components';
import { DomainLabel } from 'uix/domain/label';
import { DashSegment } from 'uix/components/grid';
import { CUSTOM_TREE_ICONS } from 'uix/types/utils';
import { groupBy, keys, mapItems } from 'ldash';
const TreeNodeLinksRows = ({ linkedRows, node, onNavigate })=>{
    let graphics = useGraphics([
        'types',
        'tree'
    ]);
    let domains = useSelector(Sel.domains);
    let i18n = useSelector(Sel.i18n);
    if (!graphics.types || linkedRows.length === 0) {
        return null;
    }
    let datatypeCounts = keys(groupBy(linkedRows, (r)=>r.lp_datatype)).length;
    let groupByDatatype = datatypeCounts > 2;
    let buildRow = (r)=>{
        let targetId = r.otid ? r.otid : encodeSlimLink(r.lp_otid, node.otid);
        let dt = r.lp_datatype;
        let dtSt = `${dt}_${r.lp_subtype}`;
        let src = graphics.types[dtSt] || graphics.types[`${dt}_0`];
        let customTreeIcon = CUSTOM_TREE_ICONS[dtSt];
        if (customTreeIcon) {
            src = graphics?.tree?.[customTreeIcon];
        }
        return /*#__PURE__*/ _jsxs(Link, {
            odid: r.odid,
            id: targetId,
            style: {
                fontWeight: node.otparent == r.lp_otid ? 'bold' : null
            },
            onClicked: onNavigate,
            children: [
                /*#__PURE__*/ _jsx(Image, {
                    inline: true,
                    width: "14px",
                    src: src,
                    style: {
                        marginTop: '-3px'
                    }
                }),
                ' ',
                /*#__PURE__*/ _jsx("span", {
                    children: r.lp_caption || i18n.getType(dt, r.lp_subtype) || targetId
                })
            ]
        }, `${r.lp_otid}_${r.otid}`);
    };
    let buildRows = (rows)=>rows.map((r)=>/*#__PURE__*/ _jsx("div", {
                children: buildRow(r)
            }, `${r.lp_otid}_${r.otid}`));
    let odid2links = groupBy(linkedRows, (r)=>r.odid);
    return mapItems(odid2links, (odid, rows)=>{
        let dname = domains.odid2name[odid];
        if (!dname) {
            return null;
        }
        let ddata = domains.data[dname];
        return /*#__PURE__*/ _jsxs("div", {
            style: {
                lineHeight: '1.5em'
            },
            children: [
                /*#__PURE__*/ _jsx(Link, {
                    odid: odid,
                    id: null,
                    onClicked: onNavigate,
                    children: /*#__PURE__*/ _jsx(DomainLabel, {
                        dname: ddata.name
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    style: {
                        marginLeft: '25px'
                    },
                    children: groupByDatatype ? mapItems(groupBy(rows, (r)=>r.lp_datatype), (datatype, dtypeRows)=>/*#__PURE__*/ _jsxs("div", {
                            style: {
                                marginBottom: '0.5em'
                            },
                            children: [
                                /*#__PURE__*/ _jsx(DatatypeDescription, {
                                    datatype: datatype
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    style: {
                                        marginLeft: '25px'
                                    },
                                    children: buildRows(dtypeRows)
                                })
                            ]
                        }, `${odid}_${datatype}`)) : buildRows(rows)
                })
            ]
        }, odid);
    });
};
export const TreeNodeLinksContent = ({ node, onNavigate, emptyMessage = 'Keine Verlinkungen vorhanden.' })=>{
    let { data, error } = useApi('tree/getNodeLinks', {
        otid: node.otid
    }, {
        condition: !!node?.otid
    });
    if (error) {
        return /*#__PURE__*/ _jsx(Message, {
            error: true,
            content: String(error)
        });
    }
    if (!data) {
        return null;
    }
    if (data.linkedRows.length === 0) {
        return /*#__PURE__*/ _jsx("div", {
            children: emptyMessage
        });
    }
    return /*#__PURE__*/ _jsx(TreeNodeLinksRows, {
        linkedRows: data.linkedRows,
        node: node,
        onNavigate: onNavigate
    });
};
export const TreeNodeLinksPanel = ({ header, icon = 'link', ...props })=>{
    let { data } = useApi('tree/getNodeLinks', {
        otid: props.node.otid
    }, {
        condition: !!props.node?.otid
    });
    if (!data || data.linkedRows.length === 0) {
        return null;
    }
    return /*#__PURE__*/ _jsx(DashSegment, {
        header: header,
        icon: icon,
        children: /*#__PURE__*/ _jsx(TreeNodeLinksRows, {
            linkedRows: data.linkedRows,
            node: props.node,
            onNavigate: props.onNavigate
        })
    });
};
